module.exports = __webpack_public_path__ + "static/img/wanted5.651f815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted5.png
// module id = 1OP0
// module chunks = 1 3